import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { map, startWith } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
export interface Pages {
  keyword: string;
  url: string;
}
@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
export class SearchComponent implements OnInit {
  public dataset: Observable<Pages[]>;
  public searchText = '';
  public searchCtrl = new FormControl();
  public pagesList: Pages[] = [
    { keyword: 'apprenti', url: 'apprenti' },
    { keyword: 'employe', url: 'employeur' },
    { keyword: 'cfa', url: 'ufa' },
    { keyword: 'contact', url: 'contact' },
    { keyword: 'actualités', url: 'actualites' },
    { keyword: 'ecole', url: 'ufa' },
    { keyword: 'formations', url: 'formations' },
  ];
  @Input() menuIsClosed: boolean;
  @Output() IsClicked = new EventEmitter<any>();
  
  constructor(private router: Router) {}

  ngOnInit(): void {
    this.dataset = this.searchCtrl.valueChanges.pipe(
      startWith(''),
      map((page) => (page ? this.filterPages(page) : this.pagesList.slice()))
    );
  }

  filterPages(value: string): Pages[] {
    const filterValue = value.toLowerCase();
    return this.pagesList.filter(
      (page) =>
        page.keyword.toLowerCase().includes(filterValue) ||
        filterValue.includes(page.keyword.toLowerCase())
    );
  }

  search(url) {
    this.router.navigateByUrl(url);
    this.menuIsClosed = true;
    this.IsClicked.emit(this.menuIsClosed);
  }
}
